import { Campaign, CampaignReference, CampaignWithReference, YammerState } from '../../state/types';
import { findCampaignById } from '../campaigns/selectors';
import { createFindById, createFindByIdThrows } from '../findById';

export const findCampaignReferenceById = createFindById<CampaignReference>('campaignReferences');
export const findCampaignReferenceByIdThrows = createFindByIdThrows<CampaignReference>('campaignReferences');

type GetCampaignTelemetryId = (
  state: YammerState,
  campaignId: Campaign['id']
) => CampaignReference['telemetryId'] | undefined;
export const getCampaignTelemetryId: GetCampaignTelemetryId = (state, campaignId) =>
  findCampaignReferenceById(state, campaignId)?.telemetryId;

type GetFulfilledCampaignReferences = (state: YammerState) => Record<string, CampaignReference>;
export const getFulfilledCampaignReferences: GetFulfilledCampaignReferences = (state) =>
  state.campaignReferences.fulfilled.byId;

type GetCampaignWithReference = (state: YammerState, campaignId: Campaign['id']) => CampaignWithReference | undefined;
export const getCampaignWithReference: GetCampaignWithReference = (state, campaignId) => {
  const campaignReference = findCampaignReferenceById(state, campaignId);
  const campaign = findCampaignById(state, campaignId);

  if (!campaignReference || !campaign) {
    return undefined;
  }

  const campaignWithReference = {
    ...campaign,
    ...campaignReference,
  };

  return campaignWithReference;
};
